import { render, staticRenderFns } from "./CardCreateDialog.vue?vue&type=template&id=88c72158&scoped=true&"
import script from "./CardCreateDialog.vue?vue&type=script&lang=js&"
export * from "./CardCreateDialog.vue?vue&type=script&lang=js&"
import style0 from "./CardCreateDialog.vue?vue&type=style&index=0&id=88c72158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c72158",
  null
  
)

export default component.exports